import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../utils/URLTools';
import DateFormats from '../../../../elements/DateFormats';

export const apiFetchImpcsWithMrdsDefault = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getImpcsWithMrdsDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      startDate: moment().format(DateFormats.date),
      endDate: moment().format(DateFormats.date),
    },
  });

  return axios.get(serviceUrl);
};

export const apiFetchImpcList = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getImpcList',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      startDate: moment(payload.startDate).format(DateFormats.date),
      endDate: payload.endDate ? moment(payload.endDate).format(DateFormats.date) : null,
    },
  });
  return axios.get(serviceUrl);
};
